"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResetServiceAreaModalController = /** @class */ (function () {
    function ResetServiceAreaModalController($uibModalInstance, count) {
        this.$uibModalInstance = $uibModalInstance;
        this.count = count;
        this.confirmationText = "";
    }
    ResetServiceAreaModalController.prototype.isValid = function () {
        return this.confirmationText === "RESET";
    };
    ResetServiceAreaModalController.prototype.confirm = function () {
        if (!this.isValid()) {
            return;
        }
        this.$uibModalInstance.close();
    };
    ResetServiceAreaModalController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    return ResetServiceAreaModalController;
}());
ResetServiceAreaModalController.$inject = ["$uibModalInstance", "count"];
exports.default = ResetServiceAreaModalController;
